import { Clock, DownloadSimple, Trash } from "@phosphor-icons/react";
import {
  fmtDateTime, fmtSize, DESTINATION_LABEL, STATUS_BADGE, typeBadgeClass, typeLabel,
} from "@/components/backup/backupUtils";

function renderRowDetail(r) {
  if (r.error) return <span className="text-[#E60000]">{r.error}</span>;
  if (r.email_sent_to) return <span>→ {r.email_sent_to}</span>;
  if (r.drive_view_link) return <a href={r.drive_view_link} target="_blank" rel="noreferrer" className="underline">{r.drive_file_name}</a>;
  if (r.drive_file_name) return <span>{r.drive_file_name}</span>;
  if (r.destination === "download") return <span className="text-zinc-500">Arquivo local</span>;
  return "—";
}

export default function BackupHistoryTable({ history, loading, isAdmin, onDownload, onDelete }) {
  return (
    <section className="border border-black bg-white" data-testid="backup-history">
      <div className="border-b border-black px-6 py-4 flex items-center gap-2">
        <Clock size={18} weight="bold" />
        <div className="font-head font-bold text-lg">Histórico de Backups</div>
        <div className="text-xs text-zinc-500 ml-auto">Retenção: 12 meses</div>
      </div>
      {loading ? (
        <div className="text-zinc-400 py-10 text-center">Carregando…</div>
      ) : history.length === 0 ? (
        <div className="text-zinc-400 py-10 text-center">Nenhum backup executado ainda.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="table">
            <thead>
              <tr>
                <th>Data / Hora</th>
                <th>Tipo</th>
                <th>Destino</th>
                <th>Status</th>
                <th>Tamanho</th>
                <th>Duração</th>
                <th>Detalhe</th>
                <th>Executado por</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {history.map((r) => {
                const status = STATUS_BADGE[r.status] || STATUS_BADGE.failed;
                const SIcon = status.Icon;
                return (
                  <tr key={r.id} data-testid={`backup-row-${r.id}`}>
                    <td className="font-mono text-xs whitespace-nowrap">{fmtDateTime(r.created_at || r.started_at)}</td>
                    <td>
                      <span className={`inline-block text-[10px] font-bold uppercase tracking-widest px-2 py-1 ${typeBadgeClass(r.type)}`}>
                        {typeLabel(r.type)}
                      </span>
                    </td>
                    <td className="text-xs">{DESTINATION_LABEL[r.destination] || r.destination}</td>
                    <td>
                      <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest px-2 py-1 ${status.cls}`}>
                        <SIcon size={11} weight="fill" /> {status.label}
                      </span>
                    </td>
                    <td className="font-mono text-xs">{fmtSize(r.size_bytes)}</td>
                    <td className="font-mono text-xs">{r.elapsed_ms ? `${(r.elapsed_ms / 1000).toFixed(1)}s` : "—"}</td>
                    <td className="text-xs max-w-[220px] truncate" title={r.error || r.email_sent_to || r.drive_file_name || ""}>
                      {renderRowDetail(r)}
                    </td>
                    <td className="text-xs">{r.triggered_by || "—"}</td>
                    <td>
                      <div className="flex items-center gap-1">
                        {r.destination === "download" && r.status === "success" && r.local_path && (
                          <button
                            className="btn btn-ghost !py-1 !px-2 text-xs"
                            onClick={() => onDownload(r)}
                            title="Baixar arquivo"
                            data-testid={`backup-download-${r.id}`}
                          >
                            <DownloadSimple size={12} weight="bold" />
                          </button>
                        )}
                        {isAdmin && (
                          <button
                            className="btn btn-ghost !py-1 !px-2 text-xs text-[#E60000]"
                            onClick={() => onDelete(r.id)}
                            title="Remover"
                            data-testid={`backup-delete-${r.id}`}
                          >
                            <Trash size={12} weight="bold" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
